// extracted by mini-css-extract-plugin
export default {"card":"UZAaU","list":"SkX3y","no-history":"wGLmF"};